<script setup>
import { ref } from 'vue';

let uid = 0;

const props = defineProps({
    name: {
        type: String,
        required: true
    },
    label: {
        type: String,
        default: ''
    },
    accept: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
        default: false
    },
    placeholder: {
        type: String,
        default: 'Datei auswählen…'
    },
    browseText: {
        type: String,
        default: 'Durchsuchen'
    },
    // Optional explicit id; auto-generated when omitted.
    inputId: {
        type: String,
        default: ''
    }
});

const emit = defineEmits(['change']);

const id = props.inputId || ('file-input-' + (++uid));
const selectedFileName = ref('');

function onChange(event) {
    const file = event.target.files && event.target.files[0];
    selectedFileName.value = file ? file.name : '';
    emit('change', event);
}

// Allow parent to imperatively reset the label (e.g. when its modal closes).
function reset() {
    selectedFileName.value = '';
}

defineExpose({ reset });
</script>

<template>
    <div class="form-group mb-3">
        <label v-if="label" class="d-block mb-1" :for="id">{{ label }}</label>
        <div class="custom-file">
            <input :id="id" class="custom-file-input" type="file" :name="name" :accept="accept" :required="required"
                @change="onChange" />
            <label class="custom-file-label" :for="id" :data-browse="browseText">
                {{ selectedFileName || placeholder }}
            </label>
        </div>
    </div>
</template>
